import { FC } from 'react';
import {
  InputProps,
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps,
  Typography,
} from '@mui/material';

export type TextFieldProps = MuiTextFieldProps & {
  maxLength?: number;
};

export const TextField: FC<TextFieldProps> = ({
  multiline,
  minRows,
  maxRows,
  slotProps: initSlotProps,
  maxLength,
  ...rest
}) => {
  const multilineProps = multiline
    ? { maxRows: maxRows ?? 15, minRows: minRows ?? 3, multiline: true }
    : undefined;

  const slotProps = maxLength
    ? {
        ...initSlotProps,
        htmlInput: { ...(initSlotProps?.htmlInput ?? {}), maxLength },
        input: {
          ...(initSlotProps?.input ?? {}),
          endAdornment: (
            <>
              <Typography color='text.disabled' pl={0.5} variant='caption'>
                {String(rest.value ?? '').length}/{maxLength}
              </Typography>
              {(initSlotProps?.input as InputProps)?.endAdornment}
            </>
          ),
        },
      }
    : initSlotProps;

  return <MuiTextField {...multilineProps} {...rest} slotProps={slotProps} />;
};
